<template>
  <div v-if="readOnly" class="w-full">
    <Figure :figureData="figureData" />
  </div>
  <div v-else class="w-full">
    <Figure :figureData="figureData" />
  </div>
</template>

<script>
import Figure from './Figure.vue';

export default {
  props: {
    figureData: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Figure,
  },
};
</script>
